import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import uuid from 'react-uuid';
import { FilterStyledWrapper } from './filter.styled.js';
import Item from './item';

const Filter = ({ objects, values, setFilter }) => {
  const [filters, setFilters] = useState(values || { id: 0 });
  const { t } = useTranslation();
  useEffect(() => {
    setFilter({
      ...filters,
    });
  }, [filters, setFilter]);

  return (
    <FilterStyledWrapper className="flex-column card filter-menu absolute">
      <div className="flex items-center justify-between pxy-4">
        <label className="normal-text">{t('FILTER')}</label>
        <div
          className="flex items-center justify-center cursor clear-all no-select"
          onClick={() => setFilters({ id: uuid() })}>
          <label className="normal-text px-2" style={{ color: '#FF406E' }}>
            {t('CLEAR')}
          </label>
        </div>
      </div>
      <div>
        <Item
          filter={{ ...filters, objects: objects }}
          setFilter={f => setFilters(f)}
          removeFilter={f => setFilters({ id: uuid() })}
        />
      </div>
    </FilterStyledWrapper>
  );
};

export default Filter;
